<template>
    <div class="d-contents">
        <router-view/>
        <div id="loading-template" is="template">
            <Loading variant="primary-text"/>
        </div>
    </div>
</template>

<script>
import store from './app/store/index.js'

export default {
    name: 'App',
    store,
    methods: {
        setupResizibleContainer() {
            (new ResizeObserver(entries => {
                parent.postMessage({ height: entries[0].contentRect.height }, "*")
            })).observe(document.body)
        },
		temaAlterado(ev) {
			if (ev.data.tema) {
				// https://www.w3schools.com/css/css3_variables_javascript.asp
				let root = document.querySelector(':root')
				Object.entries(ev.data.colors).forEach(cor => root.style.setProperty(`--${cor[0]}`, cor[1]))

				root.style.setProperty("--main-color", ev.data.tema.corA)
				root.style.setProperty("--main-color-alt", ev.data.tema.corA)
				root.style.setProperty("--main-color-action", ev.data.tema.corA)
				root.style.setProperty("--main-color-mask", `${ev.data.tema.corA}1C`)

                this.$store.commit('setAtualizado', true)
                setTimeout(() => this.$store.commit('setAtualizado', false), 500)
			}
		},
    },
    mounted() {
        window.addEventListener('message', this.temaAlterado)
        this.setupResizibleContainer()
    },
    beforeDestroy() {
        window.removeEventListener('message', this.temaAlterado)
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  // Import Main styles for this application
  @import '@/app/assets/styles/bootstrap.scss';
  @import '@/app/assets/styles/app.scss';
  @import '@/app/assets/styles/smartBrain.scss';

</style>

